import React from 'react';
import { COLUMN_2 } from 'Components/frameworks/card/Card.constants';
import { mapColToCard } from 'Components/utils/cards/cards.utils';
import { Card } from 'Components/frameworks/card/Card';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { asMapColInput, castAs } from 'Src/types/cast-helpers';
type MapColToCardInput = Parameters<typeof mapColToCard>[0];
type Props = {
  columns: Array<CMSCard>;
  displayLoadMore?: boolean;
  id?: string;
  title?: string;
};
export const MediaThumbnailLine = ({ columns = [], displayLoadMore, id, title }: Props) => {
  if (!columns.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <div className="grid grid-cols-1 gap-20 sm:grid-cols-3">
        {columns.map((col, idx) => (
          <Card
            {...mapColToCard(
              castAs<MapColToCardInput>(asMapColInput({ ...col, displayRatio: 1 / 3 })),
            )}
            displayLoadMore={displayLoadMore}
            key={idx}
            layout={COLUMN_2}
            theme="thumbnail"
          />
        ))}
      </div>
    </SiteContainer>
  );
};
